<template>
  <fragment>
    <div v-if="!isExamForm" class="column is-3">
      <b-field
        class="ws-field"
        :label="$t('День ПД')"
      >
        <ws-datepicker
          v-model="day_cm1"
          v-validate="'correctDate'"
          name="day_cm1"
          disabled="disabled"
          class="ws-field__control">
        </ws-datepicker>
      </b-field>
    </div>
    <div class="column">
      <b-field
        class="ws-field"
        :label="$t('Выдача задания')"
        :type="{
          'is-danger': errors.has('job_issued_at'),
          'is-warning': (validateJobIssuedAt || validateHolidayJobIssuedAt) && !errors.first('job_issued_at')
        }"
        :message="manyErrors([errors.first('job_issued_at'), validateHolidayJobIssuedAt, validateJobIssuedAt])"
      >
        <ws-datepicker
          v-validate="{
            required: true,
            validateMinDate: [day_cm1, 'ПД'],
            correctDate: true
          }"
          :disabled="disabledDates"
          @input="onJobIssuedAtChange"
          :min-date="minDate"
          :focused-date="day_cm1"
          v-model="job_issued_at"
          name="job_issued_at"
          class="ws-field__control">
        </ws-datepicker>
      </b-field>
    </div>
    <div class="column">
      <b-field
        class="ws-field"
        :label="$t('Дата начала')"
        :type="{
          'is-danger': errors.has('started_at'),
          'is-warning': (validateStartedAt || validateHolidayStartedAt) && !errors.first('started_at')
        }"
        :message="manyErrors([errors.first('started_at'), validateHolidayStartedAt, validateStartedAt])"
      >
        <ws-datepicker
          v-model="started_at"
          v-validate="{
            required: true,
            validateMinDate: [day_cm1, 'ПД'],
            correctDate: true
          }"
          :focused-date="day_cm1"
          :disabled="disabledDates"
          :min-date="minDate"
          name="started_at"
          class="ws-field__control">
        </ws-datepicker>
      </b-field>
    </div>
    <div class="column">
      <b-field
        class="ws-field"
        :label="$t('Дата окончания')"
        :type="{
          'is-danger': errors.has('ended_at'),
          'is-warning': (validateEndedAt || validateHolidayEndedAt) && !errors.first('ended_at')
        }"
        :message="manyErrors([errors.first('ended_at'), validateHolidayEndedAt, validateEndedAt])"
      >
        <ws-datepicker
          v-model="ended_at"
          v-validate="{
            required: true,
            validateMinDate: [day_cm1, 'ПД'],
            correctDate: true
          }"
          :focused-date="day_cm1"
          :disabled="disabledDates"
          :min-date="minDate"
          name="ended_at"
          class="ws-field__control">
        </ws-datepicker>
      </b-field>
    </div>
    <div class="column is-12">
      <div
        class="columns is-multiline is-righted"
        v-for="(g, index) in values.groups" :key="g.id || g.guid"
      >
        <div class="column is-2">
          <div v-if="index === 0">
            <b-field
              class="ws-field is-required"
              :label="$t('№ Смены')"
              :type="{'is-danger': errors.has('shift_number')}"
              :message="errors.first('shift_number')"
            >
              <b-select
                class="ws-field__control"
                name="shift_number"
                v-validate="{ required: true }"
                v-model="values.number"
                expanded
              >
                <option
                  v-for="option in shiftNumbers"
                  :value="option"
                  :key="option"
                >
                  {{ option }}
                </option>
              </b-select>
            </b-field>
          </div>
        </div>
        <div class="column">
          <ws-request-group-field
            :group="g"
            :setEducationGroup="(val) => setEducationGroup(val, index)"
            :exam="exam"
          />
        </div>
        <div class="column is-3 floated-button-container">
          <b-field
            class="ws-field is-required"
            :label="$t('Сдающих (план)')"
            :type="{'is-danger': errors.has('student'+(g.id || g.guid))}"
            key="student-input"
            :message="errors.first('student'+(g.id || g.guid))"
          >
            <b-input
              class="ws-field__control"
              v-model.number="g.student"
              v-validate="{ required: true }"
              :name="'student'+(g.id || g.guid)"
            />
          </b-field>
        </div>
        <div v-if="!isExamForm" class="column is-3 floated-button-container">
          <b-field
            class="ws-field is-required"
            :label="$t('Сдающих НОК (план)')"
            :type="{'is-danger': errors.has('independent_estimate_participants_number'+(g.id || g.guid))}"
            key="independent_estimate_participants_number-input"
            :message="errors.first('independent_estimate_participants_number'+(g.id || g.guid))"
          >
            <b-input
              class="ws-field__control"
              v-model.number="g.independent_estimate_participants_number"
              :disabled="!isIndependentEstimate"
              v-validate="{ required: isIndependentEstimate, min_value: 0, max_value: g.student }"
              :name="'independent_estimate_participants_number'+(g.id || g.guid)"
            />
          </b-field>
          <b-button
            v-if="index > 0 && !isExamForm"
            type="is-text"
            class="ws-button floated-button"
            @click="deleteGroupRow(index)"
          >
            <ws-icon
              class="ws-button__icon"
              name="trash"
              color="#EB5757"
              :fill="false"
              width="14"
              height="14"
            />
          </b-button>
        </div>
        <div v-if="index < values.groups.length - 1" class="column is-10">
          <div class="divider is-grey-lighter is-vcentered"></div>
        </div>
      </div>
    </div>
    <div v-if="!isExamForm" class="column is-12">
      <div class="columns is-vcentered">
        <div class="column is-2">
          <b-button class="ws-button" @click="addGroupRow()">
            <ws-icon
              class="ws-button__icon"
              name="plus-circle"
              color="#6D9AE8"
              :fill="false"
              width="14"
              height="14"
            />
            Добавить
          </b-button>
        </div>
        <div class="column is-10">
          <div class="divider is-grey-lighter is-vcentered"></div>
        </div>
      </div>
    </div>
  </fragment>
</template>

<script>
import { mapGetters } from 'vuex'
import moment from 'moment'
import { computedDate } from '@/utils/computedDateProp'
import { getShiftNumbers, validateDatesDiff, validateCurrentYear, toUTCDay } from '@/utils/helpers'
import { defaultGroupState } from '@/utils/getDefaultGroupState'
import { constants, ERRORS_MESSAGES, MESSAGE_EXAM_KEYS } from '@/services/constants.service'

let groupStateId = 0

export default {
  name: 'ws-request-exam-group-form',
  inject: {
    $validator: '$validator'
  },
  props: {
    complexityLevel: {
      type: String,
      default: () => ''
    },
    disabledDates: {
      type: Boolean,
      default: false
    },
    exam: {
      type: Object
    },
    deleteGroupRow: {
      type: Function,
      default () {}
    },
    isExamForm: {
      type: Boolean,
      default: false
    },
    values: {
      type: Object,
      default: () => ({
        groups: [
          defaultGroupState({ exam: this.exam, groupStateId })
        ],
        shift: {},
        job_issued_at: null,
        started_at: null,
        ended_at: null,
        number: 1
      })
    }
  },
  data () {
    return {
      datesInfo: {},
      shiftNumbers: getShiftNumbers()
    }
  },
  computed: {
    ...mapGetters('calendarGeneral', ['datesCalendar']),
    isIndependentEstimate () {
      return this.exam.flags.indexOf(constants.exam_flags.INDEPENDENT_ESTIMATE) > -1
    },
    job_issued_at: computedDate('values', 'job_issued_at'),
    started_at: computedDate('values', 'started_at'),
    ended_at: computedDate('values', 'ended_at'),
    day_cm1: computedDate('exam', 'day_cm1'),
    minDate () {
      const date = moment(this.day_cm1).add(-1, 'days').format('YYYY-MM-DD')
      return new Date(date)
    },
    validateStartedAt () {
      return this.validateDates({
        name: 'started_at',
        dates: [this.started_at, this.day_cm1]
      })
    },
    validateEndedAt () {
      return this.validateDates({
        name: 'ended_at',
        dates: [this.ended_at, this.started_at],
        maxDiff: 2
      })
    },
    validateJobIssuedAt () {
      return this.validateDates({
        name: 'job_issued_at',
        dates: [this.started_at, this.job_issued_at]
      })
    },
    validateHolidayStartedAt () {
      return this.errorDayCmDayOff(this.started_at)
    },
    validateHolidayEndedAt () {
      return this.errorDayCmDayOff(this.ended_at)
    },
    validateHolidayJobIssuedAt () {
      return this.errorDayCmDayOff(this.job_issued_at)
    }
  },
  methods: {
    validateDates ({ name, dates = [], maxDiff = 1 }) {
      const messageKey = MESSAGE_EXAM_KEYS[name]
      const messageYear = validateCurrentYear(dates[0])
      const validDiff = validateDatesDiff(dates[0], dates[1], maxDiff)
      return !validDiff ? ERRORS_MESSAGES[messageKey] : messageYear
    },
    onJobIssuedAtChange (value) {
      const issuedAt = moment(value)
      if (issuedAt.isValid()) {
        if (this.complexityLevel[0] !== undefined) {
          switch (this.complexityLevel[0]) {
            case '1':
              this.started_at = issuedAt.add(1, 'days')
              this.ended_at = issuedAt
              break
            case '2':
              this.started_at = issuedAt.add(1, 'days')
              this.ended_at = issuedAt.add(1, 'days')
              break
            case '3':
              this.started_at = issuedAt.add(1, 'days')
              this.ended_at = issuedAt.add(2, 'days')
              break
            default:
              this.started_at = null
              this.ended_at = null
          }
        }
      }
    },
    manyErrors (errors) {
      const manyError = []
      errors.forEach(error => {
        manyError.push(error)
      })
      return manyError.filter(Boolean).join('.\n')
    },
    addGroupRow () {
      this.values.groups.push(defaultGroupState({ exam: this.exam, groupStateId }))
    },
    setEducationGroup (eduGroup, index) {
      this.values.groups[index].education_group = eduGroup
    },
    errorDayCmDayOff (value) {
      // или год из значения или текущий год
      const currentYear = value ? new Date(value).getFullYear() : new Date().getFullYear()
      // получение нужного массива по году из стора
      const events = this.datesCalendar && this.datesCalendar[currentYear]
        ? this.datesCalendar[currentYear].list : []
      // входил ли выбранная дата в массив, если входит, значит это или выходной или прадничный день
      return events.find(function (elem) {
        return value && elem.date.getTime() === new Date(toUTCDay(value).toISOString()).getTime()
      }) ? 'Обратите внимание, в датах ДЭ присутствуют выходные или праздничные дни' : ''
    }
  }
}
</script>
